import { httpwmsapi } from 'src/services';
import queryString from 'query-string';

// Action Types
export const Types = {
  STOCK_LOADING: 'stock/loading',
  STOCK_SET_STORAGE: 'stock/set/storage',
  STOCK_SET_TYPES: 'stock/set/types',
  STOCK_SET_ADDRESS: 'stock/set/address',
  STOCK_SET_PAGING: 'stock/set/paging',
};

// Reducer
const initialState = {
  loading: false,
  storages: [],
  types: [],
  stock_address: [],
  paging: { limit: 25, offset: 0, total: 0 },
};

// Action Creators
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.STOCK_LOADING:
      return { ...state, loading: action.payload };
    case Types.STOCK_SET_STORAGE:
      return { ...state, storages: action.payload };
    case Types.STOCK_SET_TYPES:
      return { ...state, types: action.payload };
    case Types.STOCK_SET_ADDRESS:
      return { ...state, stock_address: action.payload };
    case Types.STOCK_SET_PAGING:
      return { ...state, paging: action.payload };
    default:
      return state;
  }
}

export const Creators = {
  stockLoading: (value) => ({
    type: Types.STOCK_LOADING,
    payload: value,
  }),
  stockSetStorage: (value) => ({
    type: Types.STOCK_SET_STORAGE,
    payload: value,
  }),
  stockSetTypes: (value) => ({
    type: Types.STOCK_SET_TYPES,
    payload: value,
  }),
  stockSetAddress: (value) => ({
    type: Types.STOCK_SET_ADDRESS,
    payload: value,
  }),
  stockSetPaging: (paging) => ({
    type: Types.STOCK_SET_PAGING,
    payload: paging,
  }),
  getStorageAddressList: (storage_id, filters) => {
    const qry = queryString.stringify(filters, { arrayFormat: 'index' });
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/stock/${storage_id}/positions?${qry}`, { timeout: 1000 * 30 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getStorageList: (filters) => {
    const qry = queryString.stringify(filters, { arrayFormat: 'index' });
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/stock?${qry}`, { timeout: 1000 * 15 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getStorageTypes: () => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/inventario/types`, { timeout: 1000 * 15 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  deleteStorageMapped: ({ address_id, variation_id }) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .delete(`/v1/stock/mapped/${address_id}/${variation_id}`, {
          timeout: 1000 * 15,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  deleteStorage: (storage_id) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .delete(`/v1/stock/storage/${storage_id}`, { timeout: 1000 * 15 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  editStorage: (body, storage_id) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .put(`/v1/stock/storage/${storage_id}`, body, { timeout: 1000 * 15 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  createStorage: (body) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .post(`/v1/stock/storage`, body, { timeout: 1000 * 15 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getAddressInfos: (cep) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/stock/address/cep/${cep}`, { timeout: 1000 * 15 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  updateMainAddress: (body) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .put(`/v1/stock/update/main-address`, body, { timeout: 1000 * 15 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getAddressList: (filters) => {
    const qry = queryString.stringify(filters, { arrayFormat: 'index' });
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/stock/only-address?${qry}`, { timeout: 1000 * 15 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getStorageInfosToPermissions: (filters) => {
    const qry = queryString.stringify(filters, { arrayFormat: 'index' });
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/stock/storage-infos-to-permissions?${qry}`, { timeout: 1000 * 15 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getStorageAddress: (storage_id) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/stock/${storage_id}/addresses`, { timeout: 1000 * 60 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  deleteStorageAddressCache: (storage_id) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .delete(`/v1/stock/${storage_id}/addresses/cache`, { timeout: 1000 * 15 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  deleteStorageAddressFilterCache: (storage_id) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .delete(`/v1/stock/${storage_id}/addresses/cache/filter`, { timeout: 1000 * 15 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
};
